import { context } from '@bikemap/js/services'
import { logError } from '@bikemap/js/utility'

const routeId = context.page('routeId')

/**
 * Inject rel="ugc,nofollow" attribute to anchor links.
 * Used for route description for SEO purposes.
 */
export function injectAnchorRel() {
    document.querySelectorAll('.js-inject-a-rel a').forEach(a => {
        a.setAttribute('rel', 'ugc,nofollow')
    })
}

/**
* Link shouldn't be in the DOM to prevent search engines to crawl it. For SEO purposes.
*/
export function injectDeepLinks() {
    document.querySelectorAll('.js-inject-deep-link').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            try {
                window.location.href = getDeeplinkUrl(el)
            } catch (error) {
                logError('Fetch deep link', error, { el, e })
            }
        })
    })
}

/**
 * Build URL for fetching the dynamic link based on the element's data attributes.
 * @param {Element} el
 */
export function getDeeplinkUrl(el) {
    const campaignParam = el.getAttribute('data-utm-campaign')
    return 'https://page.bikemap.it/r/' +
        routeId +
        '?utm_source=website&utm_medium=route_detail&utm_campaign=' +
        campaignParam
}
